module.exports = __webpack_public_path__ + "img/add_col_after.a798371.svg";